import { initializeExceptionsAPI } from './exceptions';
import { initializeLogsAPI } from './logs';
import { initializeMeasurementsAPI } from './measurements';
import { initializeMetaAPI } from './meta/initialize';
import { initializeTracesAPI } from './traces';
export function initializeAPI(config, transports, metas) {
    const tracesApi = initializeTracesAPI(transports, metas);
    return Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, tracesApi), initializeExceptionsAPI(config, transports, metas, tracesApi)), initializeMetaAPI(transports, metas)), initializeLogsAPI(transports, metas, tracesApi)), initializeMeasurementsAPI(transports, metas, tracesApi));
}
//# sourceMappingURL=initialize.js.map